import React from "react";
import IntegrationReactSelect from "../Autocomplete";
import {observable} from "mobx";
import {inject, observer} from "mobx-react";
import i18n from "i18next";

@inject('menuStore')
@observer
class NavigationEditor extends React.Component<any, any> {

    @observable menu: any[] = [];

    @observable loading: boolean= false;

    async componentWillMount(): Promise<any> {
        this.loading = true;
        await this.props.menuStore.fetch();
        this.menu =  this.props.menuStore.items;
        this.loading = false;
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {
        return (
            <>
                <IntegrationReactSelect
                    placeholder={i18n.t('Choose Menu label')}
                    loading={this.loading}
                    value={this.props.widget.data.menu}
                    suggestions={this.menu}
                    inputChange={() => {
                    }}
                    onChange={(data:any)=>this.props.onUpdateData('menu',data)}/>
            </>
        );
    }
}

export default NavigationEditor;

